import DonorIcon from '@material-ui/icons/People';
import DonorList from './DonorList';
import DonorEdit from './DonorEdit';
import DonorCreate from './DonorCreate';
import DonorView from './DonorView'

export default {
    list: DonorList,
    show: DonorView,
    edit:  DonorEdit,
    create: DonorCreate,
    icon: DonorIcon,
};
